<template>
  <Popup :open="open" :width="300" :position="{ top: 42, right: -153 }" :border="'none'" :border-radius="4">
    <div class="popup">
      <div class="pointer" />
      <div class="user_info">
        <div class="left">
          <img
            class="avatar"
            :src="require(`@/assets/img/SearchBar/default_avatar${userInfo.sex === 'f' ? '_f' : ''}.png`)"
            alt="default_avatar"
            width="46"
            height="46"
          />
        </div>
        <div class="right">
          <div class="right_top">
            <div class="nickname" :title="userInfo.linkName">
              {{ userInfo.linkName || "未命名" }}
            </div>
            <div class="label" v-if="isShowLabel" @click="handleExcellentSupplierClick">
              <img src="@/assets/img/LayoutHeader/gold-medal.png" alt="medal" />优秀供应商
            </div>
          </div>
          <div class="right_bottom">
            <div class="companyName" :title="userInfo.companyName">
              {{ userInfo.companyName || "未填写公司名称" }}
            </div>
          </div>
        </div>
      </div>
      <div class="member">
        <div class="left">
          <div class="left_top">{{ userInfo.memberLevelName }}</div>
          <div class="left_bottom">
            <span class="area" :title="userInfo.areaName">{{ userInfo.areaName }}</span>
            <span class="expire_date" v-if="authCheck(AUTH_KEY_MAP.EXPIRE_DATE_VISIBLE)">
              &nbsp;&nbsp;|&nbsp;&nbsp;{{ userInfo.expireDate }}到期
            </span>
          </div>
        </div>
        <div class="right" @click="handleUpgradeClick">
          <img v-if="authCheck(AUTH_KEY_MAP.UPGRADE_BTN)" src="@/assets/img/LayoutHeader/btn_upgrade.png" alt="btn" />
          <img v-else src="@/assets/img/LayoutHeader/btn_upgrade&renew.png" alt="btn" />
        </div>
      </div>
      <div class="cell no-hover">
        <span>{{ userInfo.username }}</span
        ><span class="tip">用户名</span>
      </div>
      <div class="cell" @click="handleUserInfoClick">
        <span>账号信息</span>
      </div>
      <div class="cell" @click="handleUserCenterClick">
        <span>会员中心</span>
      </div>
      <div v-if="authCheck(AUTH_KEY_MAP.HELP_CENTER_ENTRY)" class="cell" @click="handleHelpCenterClick">
        <span>帮助中心</span>
      </div>
      <div class="logout">
        <div class="cell" @click="handleLogoutClick">
          <span>退出登录</span>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Popup from "@/components/common/Popup";
import { USER_CENTER_URL } from "@/utils/constants/constants.menu";
import { ACCOUNT_MANAGE_ACCOUNT_INFO_URL } from "@/utils/constants/constants.menu";
import { EXCELLENT_SUPPLIER_URL } from "@/utils/constants/constants.user-center";
import { authCheck, LOGOUT_TYPE, redirectToLoginPage } from "@/utils/common";
import { restLogout } from "@/services/common/basic";
import { AUTH_KEY_MAP } from "@/utils/constants/constants.auth";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";
import { CHOOSE_PACKAGE } from "@/utils/constants/constants";
import { restPayPayDialogInfoNeedBuyMoreDialog } from "@/services/common/dialog-sub-account-buy";
import { restAccountSupplierStarSearch } from "@/services/common/basic";
export default {
  name: "PopupUserV2",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      AUTH_KEY_MAP,
    };
  },
  components: { Popup },
  computed: {
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    isShowLabel() {
      const roleId = this.$store.getters["basic/userInfo"].roleId;
      const starLevel = this.$store.getters["basic/userInfo"].excellentSupplierStarLevel;
      return roleId === 2 || starLevel !== 0;
    },
  },
  created() {
    console.log("111");
    this.getExcellentSupplierStarLevel();
  },
  methods: {
    authCheck,
    async getExcellentSupplierStarLevel() {
      let excellentSupplierStarLevel = 0;
      try {
        excellentSupplierStarLevel = await restAccountSupplierStarSearch().then((res) => res.data);
      } catch (e) {
        e;
      }
      console.log(excellentSupplierStarLevel, "excellentSupplierStarLevelexcellentSupplierStarLevel");
      this.$store.commit("basic/updateUserInfo", {
        ...this.userInfo,
        excellentSupplierStarLevel,
      });
    },
    handleExcellentSupplierClick() {
      const starLevel = this.userInfo.excellentSupplierStarLevel;
      if (starLevel === 1) return;
      window.open(EXCELLENT_SUPPLIER_URL);
    },
    handleUpgradeClick() {
      this.$track(DEED_MAP.CLICK, OID_MAP.CHOOSE_PACKAGE_PAGE_CLICK);
      if (authCheck(AUTH_KEY_MAP.UPGRADE_BTN)) {
        restPayPayDialogInfoNeedBuyMoreDialog({ type: 15 }).then((res) => {
          if (res.code !== 200) {
            return;
          }
          if (res.data.needDialog === true) {
            //sourceType: 1, //来源类型 1:'新企业套餐页',2:'2.0会员中心首页',3:'2.0顶部个人信息顶部弹框',4:'2.0会员套餐页' selectedPackage：1 普通会员  2 高级会员  3VIP
            window.open(CHOOSE_PACKAGE + "?sourceType=3");
          } else {
            this.$message.warning(`请联系您的专属客服进行开通～`);
          }
        });
      } else {
        this.$message.warning(`请联系您的专属客服进行开通～`);
      }
      this.$emit("cell", "upgrade");
    },
    handleUserInfoClick() {
      this.$router.push({
        path: ACCOUNT_MANAGE_ACCOUNT_INFO_URL,
      });
      this.$emit("cell", "user-info");
    },
    handleUserCenterClick() {
      window.location.href = USER_CENTER_URL;
      this.$emit("cell", "user-center");
    },
    handleHelpCenterClick() {
      this.$emit("cell", "help-center");
    },
    handleLogoutClick() {
      this.$libMsgBox({
        title: "提示",
        message: "您确定要退出登录？",
        type: "warning",
      })
        .then(async () => {
          this.$message({
            message: "您已退出",
            type: "info",
            onClose: () => {
              redirectToLoginPage(LOGOUT_TYPE.MANUAL);
            },
          });
          await restLogout();
        })
        .catch(() => {});
      this.$emit("cell", "logout");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../assets/config";

.popup {
  width: 100%;
  margin-top: -50px;
  padding-top: 50px;

  .pointer {
    margin-top: -50px;
    cursor: pointer;
    width: 100%;
    height: 50px;
  }

  .user_info {
    width: 100%;
    height: 90px;
    background: url("@/assets/img/LayoutHeader/bg-popup-user.png") center center no-repeat;
    background-size: cover;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    color: white;

    .left {
      display: flex;

      .avatar {
      }
    }

    .right {
      margin-left: 8px;

      .right_top {
        display: flex;
        align-items: center;

        .nickname {
          max-width: 108px;

          font-size: 18px;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 600;
          color: #ffffff;
          line-height: 25px;

          //单行
          word-break: break-all;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }

        .label {
          width: 82px;
          height: fit-content;
          background-color: #ffcec6;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 9px;

          font-size: 12px;
          font-family: NotoSansCJKsc, NotoSansCJKsc-Regular;
          font-weight: 400;
          color: #bc8600;
          line-height: 18px;
          letter-spacing: -0.61px;

          margin-left: 6px;
          cursor: pointer;

          img {
            width: 13px;
            height: 13px;
            margin-right: 1px;
            margin-left: -2px;
          }
        }
      }

      .right_bottom {
        margin-top: 9px;

        .companyName {
          max-width: 210px;

          font-size: 12px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;

          //单行
          word-break: break-all;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }
      }
    }
  }

  .member {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 18px 6px 18px 20px;
    border-bottom: 1px #e8e8e8 solid;
    margin-bottom: 8px;

    .left {
      .left_top {
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 600;
        color: #333333;
        line-height: 22px;
      }

      .left_bottom {
        font-size: 12px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-top: 8px;
        display: flex;

        .area {
          //单行
          word-break: break-all;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
        }

        .expire_date {
          flex-shrink: 0;
        }
      }
    }

    .right {
      display: flex;
      cursor: pointer;

      img {
        width: 82px;
        object-fit: contain;
      }
    }
  }

  .cell {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 12px 0 20px;

    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
    line-height: 20px;

    cursor: pointer;

    &:hover {
      background-color: rgba(223, 98, 80, 0.04);
    }

    .tip {
      font-size: 12px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
  }

  .no-hover {
    cursor: text;

    &:hover {
      background-color: white;
    }
  }

  .logout {
    margin-top: 8px;
    border-top: 1px #e8e8e8 solid;
    padding: 8px 0;
  }
}
</style>
